import { createStore } from 'vuex'
import calendar from '@/data/calend/cal'
import prazd from '@/data/calend/prazd'
import arrBook from '@/data/calend/arrBook'
import vp from '@/data/calend/vpyatok'
import zaNo from '@/data/calend/zach'
import mf from '@/data/testament/mf'
import mk from '@/data/testament/mk'
import lk from '@/data/testament/lk'
import ion from '@/data/testament/in'
import dn from '@/data/testament/dn'
import iak from '@/data/testament/iak'
import petf from '@/data/testament/petf'
import petff from '@/data/testament/petff'
import inf from '@/data/testament/inf'
import inff from '@/data/testament/inff'
import infff from '@/data/testament/infff'
import iud from '@/data/testament/iud'
import rim from '@/data/testament/rim'
import korf from '@/data/testament/korf'
import korff from '@/data/testament/korff'
import gal from '@/data/testament/gal'
import ef from '@/data/testament/ef'
import flp from '@/data/testament/flp'
import kol from '@/data/testament/kol'
import fesf from '@/data/testament/fesf'
import fesff from '@/data/testament/fesff'
import timf from '@/data/testament/timf'
import timff from '@/data/testament/timff'
import tit from '@/data/testament/tit'
import flm from '@/data/testament/flm'
import evr from '@/data/testament/evr'
import iez from '@/data/testament/iez'
import zah from '@/data/testament/zah'
import iol from '@/data/testament/iol'
import prem from '@/data/testament/prem'
import isa from '@/data/testament/isa'
import ishod from '@/data/testament/ishod'
import bit from '@/data/testament/bit'
import prit from '@/data/testament/prit'
import mal from '@/data/testament/mal'

export default createStore({
  state: {
    calendar,
    prazd,
    arrBook,
    vp,
    zaNo,
    'Мф.': mf,
    'Мк.': mk,
    'Лк.': lk,
    'Ин.': ion,
    'Деян.': dn,
    'Иак.': iak,
    '1_Пет.': petf,
    '2_Пет.': petff,
    '1_Ин.': inf,
    '2_Ин.': inff,
    '3_Ин.': infff,
    'Иуд.': iud,
    'Рим.': rim,
    '1_Кор.': korf,
    '2_Кор.': korff,
    'Гал.': gal,
    'Еф.': ef,
    'Флп.': flp,
    'Кол.': kol,
    '1_Сол.': fesf,
    '2_Сол.': fesff,
    '1_Тим.': timf,
    '2_Тим.': timff,
    'Тит.': tit,
    'Флм.': flm,
    'Евр.': evr,
    'Иез.': iez,
    'Зах.': zah,
    'Иоил.': iol,
    'Прем._Солом.': prem,
    'Ис.': isa,
    'Иcх.': ishod,
    'Быт.': bit,
    'Притч.': prit,
    'Мал.': mal
  }
})
